import WebAppCounter from "./Section/WebAppCounter.js"
import HeroApplication from "./Section/HeroApplication.js"
import WebApplicationCards from "./Section/WebApplicationCards.js"
import WebApplicationFaqs from "./Section/WebApplicationFaqs.js"


const WebApplications = () => {
  return (
    <>
    <HeroApplication/>
    <WebAppCounter/>
    <WebApplicationCards/>
    <WebApplicationFaqs/>

    
    </>
  )
}

export default WebApplications